import {
    Card,
    Skeleton,
    Tooltip,
    Button,
    Badge,
    Tag,
    Tabs,
    Drawer,
    Spin,
    Row,
    Col,
    Divider,
} from "antd";
import { useContext, useEffect, useState } from "react";
import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import { SettingContext } from "../../routes";
import HTTP from "../../services/httpService";
import { formatDate } from "../../services/util";
import CustomHeader from "../common/Header";
import CustomTable from "../common/Table";
import "./transactionDetails.css";
import { EyeOutlined } from "@ant-design/icons";
import moment from "moment";
const { TabPane } = Tabs;
import DetailsColumn from "./DetailsColumn";
import GuestInformation from "./GuestInformation";
import IdentificationDetails from "./IdentificationDetails";
import GuestBookingInformation from "./GuestBookingInformation";
import RoomDetails from "./RoomDetails";
import CashDetails from "./CashDetails";
import KeyDetails from "./KeyDetails";
import VehicleDetails from "./VehicleDetails";
import NotesInformation from "./NotesDetails";
import CustomQuestions from "./CustomQuestions";
import SelectedDisclosures from "./SelectedDisclsures";
import CustomReceipt from "./CustomReceipt";

const getTransactionStatus = (status) => {
    let strStatus = "";
    switch (status) {
        case 1:
            strStatus = "In Progress";
            break;
        case 2:
            strStatus = "Aborted";
            break;
        case 3:
            strStatus = "Completed";
            break;
        default:
            break;
    }
    return strStatus;
};

const getTransactionIDValue = (text, record) => {
    return (
        <span>
            {text}
            <br></br>
            {(record.under_age === 2 || record.under_age === 0) && (
                <Tooltip
                    title={
                        record.under_age === 2
                            ? "Cannot rent due to age restriction"
                            : "Unable to retrieve age from the ID"
                    }
                >
                    <span>
                        <Badge status="error" />
                    </span>
                </Tooltip>
            )}
            {record.notes && <Tag color="processing">NOTES</Tag>}
            {record.is_already_member && (
                <Tag color="processing">Already a Member</Tag>
            )}
            {record.is_joined && <Tag color="processing">ENROLL</Tag>}
            {record.status &&
                record.transaction_from &&
                record.transaction_from === 3 && (
                    <Tag color="processing">
                        {getTransactionStatus(record.status)}
                    </Tag>
                )}
        </span>
    );
};

function updatewithTimeDuration(record) {
    let transaction_duration = -1;
    if (
        (record.status === 2 || record.status === 3) &&
        record.transaction_date &&
        record.updated_at
    ) {
        const diff = moment.duration(
            moment(record.updated_at).diff(moment(record.transaction_date)),
        );
        const _duration = parseInt(diff.asSeconds());
        transaction_duration = _duration;
    }
    return transaction_duration;
}

function TransactionsDetails() {
    const [TransactionKioskDetailsData, setTransactionKioskDetailsData] =
        useState([]);
    const staff_id = localStorage.getItem("x-dashboard-staffid");
    const { hotel_id } = useParams();
    const [hotelTimeZone, setHotelTimeZone] = useState("");
    const [hotelNoRecordData, setHotelNoRecordData] = useState(false);
    const [historyDrawer, setHistoryDrawer] = useState(false);
    const { selectedDates } = useContext(SettingContext);
    const [start_date, end_date] = selectedDates;
    const [activeTab, setActiveTab] = useState("transactionTab");
    const [formData, setFormData] = useState({
        staff_id,
        hotel_id,
        page: 1,
        limit: 10,
        partition: 1,
        search_keyword: "",
        sort: "",
        sortBy: "DESC",
        start_date: formatDate(start_date),
        end_date: formatDate(end_date),
    });
    const [totalRecords, setTotalRecords] = useState(0);
    const [viewVisible, setViewVisible] = useState(false);
    const [transactionRecord, setViewData] = useState(null);
    const [selectedTransactionId, setSelectedTransactionId] = useState(null);
    const [isFetching, setIsFetching] = useState(false);
    const [symbol, setSymbol] = useState("$");

    const {
        status: callsDataStatus,
        data: callDataRes,
        refetch: fetchCallData,
    } = useQuery(
        "transactionDetailsKiosk",
        async () => {
            return await HTTP("/dashboard/getTransactionDetails", {
                ...formData,
            });
        },
        { enabled: false },
    );

    useEffect(() => {
        fetchCallData();
    }, []);

    useEffect(() => {
        fetchCallData();
    }, [formData]);

    useEffect(() => {
        const [start_date, end_date] = selectedDates;
        setFormData({
            ...formData,
            start_date: formatDate(start_date),
            end_date: formatDate(end_date),
        });
    }, [selectedDates]);

    useEffect(() => {
        if (callsDataStatus === "success") {
            const { result, total, tz_id } = callDataRes;
            if (result.length) {
                setHotelNoRecordData(true);
            }
            setHotelTimeZone(tz_id);
            setTotalRecords(total);
            setTransactionKioskDetailsData(result);
        }
    }, [callsDataStatus, callDataRes]);

    useEffect(() => {
        setTransactionKioskDetailsData([]);
        if (activeTab == "transactionTab") {
            setHistoryDrawer(false);
            setFormData({
                ...formData,
                partition: 1,
            });
        } else {
            setHistoryDrawer(true);
            setFormData({
                ...formData,
                partition: 2,
            });
        }
        setHotelNoRecordData(false);
        // setTransactionKioskDetailsData([]);
    }, [activeTab]);

    const columns = [
        {
            title: "Transaction ID",
            dataIndex: "operation_id",
            key: "operation_id",
            width: "15%",
            sorter: true,
            render: (text, record) => {
                return getTransactionIDValue(text, record);
            },
        },
        {
            title: "Transaction Duration",
            dataIndex: "transaction_duration",
            key: "transaction_duration",
            width: "10%",
            sorter: true,
            render: (text, record) => {
                const t = updatewithTimeDuration(record);
                if (t > 0) {
                    if (t > 59) {
                        return `${parseInt(t / 60)} minutes`;
                    }
                    return `${t} seconds`;
                }
                return "-";
            },
        },
        {
            title: "Date & Time",
            dataIndex: "transaction_date",
            key: "transaction_date",
            width: "10%",
            sorter: true,
            render: (text, record) => {
                if (text) {
                    return (
                        <span className="detail-bold">
                            {moment(text).tz(hotelTimeZone).format("LL")}
                            <br />
                            {record && record.transaction_date && (
                                <span className="below-details">
                                    {`
                    ${moment(text).tz(hotelTimeZone).format("LT")}`}
                                </span>
                            )}
                        </span>
                    );
                }
                return "-";
            },
        },
        {
            title: "Room Number",
            dataIndex: "room_number",
            key: "room_number",
            align: "center",
            width: "10%",
            sorter: true,
            render: (text, record) => {
                if (text) {
                    return text;
                }
                return <span>-</span>;
            },
        },
        {
            title: "Guest Name",
            dataIndex: "first_name",
            key: "first_name",
            align: "center",
            width: "10%",
            sorter: true,
            render: (text, record) => (
                <span>
                    {record.first_name &&
                    record.last_name &&
                    record.first_name !== "" &&
                    record.last_name !== ""
                        ? `${record.first_name
                              .charAt(0)
                              .toUpperCase()}${record.first_name.slice(
                              1,
                          )} ${record.last_name
                              .charAt(0)
                              .toUpperCase()}${record.last_name.slice(1)}`
                        : "-"}
                </span>
            ),
        },
        {
            title: "Check-In Date & Check-Out Date",
            dataIndex: "checkin_date",
            key: "checkin_date",
            align: "center",
            width: "15%",
            sorter: true,
            render: (text, record) => {
                return (
                    <span className="detail-bold">
                        {text ? moment(text).utc().format("MMM DD, YYYY") : "-"}
                        <br />
                        {record && record.checkout_date && (
                            <span className="below-details">
                                {`
                ${moment(record.checkout_date).utc().format("MMM DD, YYYY")}`}
                            </span>
                        )}
                    </span>
                );
            },
        },
        {
            title: "Action",
            dataIndex: "action",
            key: "action",
            align: "center",
            width: "7%",
            render: (text, record) => {
                return (
                    <Tooltip title="view" key="view" placement="bottom">
                        <Button
                            onClick={() => showDetails(record.operation_id)}
                        >
                            <EyeOutlined className="action-icon" />
                        </Button>
                    </Tooltip>
                );
            },
        },
    ];
    function handleTableChange(pagination, _, sorter) {
        const { current, pageSize } = pagination;
        const { order, field } = sorter;
        const others = {
            page: current,
            limit: pageSize,
        };
        if (order !== undefined) {
            others.sorting = order === "ascend" ? 1 : 2;
            others.sort_by = field;
        } else {
            delete formData.sorting;
            delete formData.sort_by;
        }
        const newFormData = { ...formData, ...others };
        setFormData(newFormData);
    }
    const getDetailsColumnValue = (record) => {
        // console.log(JSON.stringify(record));
        let str = "-";
        if (record && record.operationData) {
            record = record.operationData[0];
        }
        if (record && record.operation_id) {
            str = record.operation_id;
            if (record.under_age === 0 || record.under_age === 2) {
                return (
                    <span>
                        {str}
                        <Tooltip
                            title={
                                record.under_age === 2
                                    ? "Cannot rent due to age restriction"
                                    : "Unable to retrieve age from the ID"
                            }
                        >
                            <Badge status="error" />
                        </Tooltip>
                    </span>
                );
            }
        }
        return str;
    };
    const {
        status: viewTransactionDetailStatus,
        data: viewTransactionDetailRes,
        refetch: fetchViewTransactionDetailCall,
    } = useQuery(
        "singleTransactionDetailKiosk",
        async () => {
            return await HTTP("/dashboard/viewTransactionDetail", {
                operation_id: selectedTransactionId,
                hotel_id,
                staff_id,
            });
        },
        { enabled: false },
    );
    useEffect(() => {
        const fetchDetails = async () => {
            if (selectedTransactionId) {
                setIsFetching(true);
                const response = await fetchViewTransactionDetailCall(); // manually trigger

                if (response.status === "success") {
                    const { data, tz_id } = response.data;
                    if (
                        data &&
                        data.cashPageDetails &&
                        data.cashPageDetails[0] &&
                        data.cashPageDetails[0].rooms
                    ) {
                        data.cashPageDetails[0].rooms.map((roomObj) => {
                            const matchedCategory = categoryNames.find(
                                (obj) => obj.key === roomObj.category,
                            );
                            roomObj.category = matchedCategory
                                ? matchedCategory.value
                                : roomObj.category;
                            return roomObj;
                        });
                    }
                    setViewData(data);
                }
                setIsFetching(false);
            }
        };

        fetchDetails();
    }, [selectedTransactionId]);
    const categoryNames = [
        {
            key: "roomRefund",
            value: "Room Refund",
        },
        {
            key: "depositRefund",
            value: "Deposit Refund",
        },
        {
            key: "roomDepositRefund",
            value: "Room and Deposit Refund",
        },
        {
            key: "miscRefund",
            value: "Misc. Refund",
        },
        {
            key: "parkingRefund",
            value: "Parking Refund",
        },
        {
            key: "roomPayment",
            value: "Room Payment",
        },
        {
            key: "depositPayment",
            value: "Deposit Payment",
        },
        {
            key: "roomDepositPayment",
            value: "Room and Deposit Payment",
        },
        {
            key: "miscPayment",
            value: "Misc. Payment",
        },
        {
            key: "parkingPayment",
            value: "Parking Payment",
        },
    ];
    const showDetails = (transactionId) => {
        setViewVisible(true);
        setSelectedTransactionId(transactionId); // set the transaction ID
        // fetchViewTransactionDetailCall();        // then manually trigger fetch
    };

    const showImages = () => {
        if (historyDrawer) {
            return false;
        }
        return true;
    };

    const getFixedTwoDecimalValue = (amount) => {
        if (Number.isInteger(amount)) {
            return amount;
        }
        return parseFloat(amount).toFixed(2);
    };

    function closeViewModel() {
        setViewVisible(false);
        setViewData([]);
        setSelectedTransactionId(null);
    }
    return (
        <>
            <Card className="dashboard-container">
                <CustomHeader />
                <Tabs
                    type="card"
                    destroyOnHidden={true}
                    activeKey={activeTab}
                    onChange={(key) => {
                        setActiveTab(key);
                    }}
                >
                    <TabPane key="transactionTab" tab="Transactions">
                        {!TransactionKioskDetailsData && !hotelNoRecordData ? (
                            <Skeleton
                                active
                                title={false}
                                paragraph={{ rows: 20, width: 40 }}
                            />
                        ) : (
                            <CustomTable
                                columns={columns}
                                tableData={TransactionKioskDetailsData}
                                noOfrecords={totalRecords}
                                handleTableChange={handleTableChange}
                                rowKey="session_id"
                                className="dashboard-table"
                                isScroll
                            />
                        )}
                    </TabPane>
                    <TabPane key="transactionHistory" tab="History">
                        {!TransactionKioskDetailsData && !hotelNoRecordData ? (
                            <Skeleton
                                active
                                title={false}
                                paragraph={{ rows: 20, width: 40 }}
                            />
                        ) : (
                            <CustomTable
                                columns={columns}
                                tableData={TransactionKioskDetailsData}
                                noOfrecords={totalRecords}
                                handleTableChange={handleTableChange}
                                rowKey="session_id"
                                className="dashboard-table"
                                isScroll
                            />
                        )}
                    </TabPane>
                </Tabs>
            </Card>
            {/* <ContainerDrawer
                className="transaction-details"
                title={"Transaction Details"}
                placement="right"
                closable={false}
                width={"50%"}
                onClose={closeViewModel}
                open={viewVisible}
            > */}
            <Drawer
                className="container-drawer"
                destroyOnHidden
                placement="right"
                title={
                    <div className="drawer-header">
                        <span
                            className="drawer-title"
                            onClick={closeViewModel}
                            role="presentation"
                        >
                            {"Transaction Details"}
                        </span>
                    </div>
                }
                open={viewVisible}
                onClose={closeViewModel}
            >
                <div className="transaction-details">
                    <Spin spinning={isFetching}>
                        <div className="left-margin">
                            <Row justify="space-between">
                                {transactionRecord?.operationData?.length > 0 &&
                                    transactionRecord.operationData[0]
                                        .reservation_id && (
                                        <DetailsColumn
                                            col={5}
                                            label={"Reservation ID"}
                                            value={getDetailsColumnValue(
                                                transactionRecord,
                                            )}
                                        />
                                    )}

                                <DetailsColumn
                                    col={5}
                                    label={"Transaction Number"}
                                    value={getDetailsColumnValue(
                                        transactionRecord,
                                    )}
                                />
                                {transactionRecord?.operationData?.length > 0 &&
                                    transactionRecord.operationData[0].k_id && (
                                        <DetailsColumn
                                            col={5}
                                            label={`${transactionRecord.operationData[0].k_id}`}
                                            value={`${
                                                transactionRecord
                                                    ?.operationData[0]
                                                    ?.nickname ?? "-"
                                            }`}
                                        />
                                    )}
                                {transactionRecord?.operationData?.length > 0 &&
                                    transactionRecord.operationData[0]
                                        .staff_id && (
                                        <DetailsColumn
                                            col={5}
                                            label={"Staff name"}
                                            value={`${transactionRecord.operationData[0].staff_first_name} ${transactionRecord.operationData[0].staff_last_name}`}
                                        />
                                    )}
                            </Row>
                        </div>

                        <GuestInformation
                            transactionRecord={transactionRecord}
                            historyDrawer={historyDrawer}
                        />

                        <IdentificationDetails
                            transactionRecord={transactionRecord}
                            historyDrawer={historyDrawer}
                        />
                        {transactionRecord &&
                            transactionRecord.operationData &&
                            transactionRecord.operationData.length > 0 && (
                                <GuestBookingInformation
                                    transactionRecord={transactionRecord}
                                />
                            )}

                        {transactionRecord &&
                            transactionRecord.operationData &&
                            transactionRecord.operationData.length > 0 &&
                            transactionRecord.operationData[0].image_urls &&
                            transactionRecord.operationData[0].image_urls
                                .length > 0 &&
                            showImages() && (
                                <Card
                                    style={{
                                        marginTop: "20px",
                                        borderColor: "#ffb551",
                                    }}
                                >
                                    <Row type="flex" justify="space-between">
                                        <Col style={{ paddingTop: "5px" }}>
                                            <Badge
                                                count={"Photos"}
                                                className="details-badge"
                                            />
                                        </Col>
                                    </Row>
                                    {transactionRecord.operationData[0].image_urls.map(
                                        (url) => (
                                            <div
                                                className="id-image-container"
                                                key={url}
                                            >
                                                <Row>
                                                    <Col span={24}>
                                                        <img
                                                            src={url}
                                                            alt="scan data"
                                                            className="id-img"
                                                            style={{
                                                                maxHeight:
                                                                    "270px",
                                                            }}
                                                        />
                                                    </Col>
                                                </Row>
                                                <Divider
                                                    style={{ margin: "5px 0" }}
                                                />
                                            </div>
                                        ),
                                    )}
                                </Card>
                            )}

                        {transactionRecord &&
                            transactionRecord.cashPageDetails &&
                            transactionRecord.cashPageDetails.length > 0 &&
                            transactionRecord.cashPageDetails[0].rooms &&
                            transactionRecord.cashPageDetails[0].rooms.length >
                                0 && (
                                <>
                                    {transactionRecord.cashPageDetails[0].rooms.map(
                                        (roomObj) => (
                                            <RoomDetails
                                                key={roomObj.id}
                                                transactionRecord={
                                                    transactionRecord
                                                }
                                                room={roomObj}
                                                symbol={symbol}
                                                getFixedTwoDecimalValue={
                                                    getFixedTwoDecimalValue
                                                }
                                            />
                                        ),
                                    )}
                                    <CashDetails
                                        transactionRecord={transactionRecord}
                                        symbol={symbol}
                                        getFixedTwoDecimalValue={
                                            getFixedTwoDecimalValue
                                        }
                                    />
                                </>
                            )}

                        {transactionRecord &&
                            transactionRecord.operationData &&
                            transactionRecord.operationData.length > 0 &&
                            transactionRecord.operationData[0]
                                .selected_disclosures &&
                            transactionRecord.operationData[0]
                                .selected_disclosures.length > 0 && (
                                <SelectedDisclosures
                                    transactionRecord={transactionRecord}
                                    symbol={symbol}
                                    getFixedTwoDecimalValue={
                                        getFixedTwoDecimalValue
                                    }
                                />
                            )}

                        {transactionRecord &&
                            transactionRecord.roomKeysData &&
                            transactionRecord.roomKeysData.length > 0 && (
                                <KeyDetails
                                    transactionRecord={transactionRecord}
                                />
                            )}

                        {transactionRecord?.operationData?.length > 0 &&
                            transactionRecord.operationData[0]?.questions_ans
                                ?.length > 0 && (
                                <CustomQuestions
                                    questions_ans={
                                        transactionRecord.operationData[0]
                                            .questions_ans
                                    }
                                />
                            )}

                        {transactionRecord &&
                            transactionRecord.operationData &&
                            transactionRecord.operationData.length > 0 &&
                            transactionRecord.operationData[0]?.notes?.trim()
                                ?.length > 0 && (
                                <NotesInformation
                                    transactionRecord={transactionRecord}
                                />
                            )}

                        {transactionRecord &&
                            transactionRecord.operationData &&
                            transactionRecord.operationData.length > 0 &&
                            transactionRecord.operationData[0].vehicle_info &&
                            transactionRecord.operationData[0].vehicle_info
                                .length > 0 &&
                            transactionRecord.operationData[0].vehicle_info.map(
                                (vehicle, index) => (
                                    <VehicleDetails
                                        key={index}
                                        vehicle={vehicle}
                                        count={index}
                                    />
                                ),
                            )}
                        {/* {transactionRecord?.operationCustomReceiptData?.length > 0 && (
            <CustomReceipt
              transactionRecord={transactionRecord}
              email={transactionRecord?.operationData[0]?.email}
            />
          )} */}
                        <Card style={{ marginTop: "20px" }}></Card>
                    </Spin>{" "}
                </div>
            </Drawer>
        </>
    );
}

export { TransactionsDetails };
